import { VESTA_SALES_CALENDAR } from '@/brand/vesta-cfo-brand';

/** Primary signup CTA — use across marketing pages for consistency. */
export const PRIMARY_SIGNUP_CTA = 'Get started free';

/** Header / nav signup button label */
export const HEADER_SIGNUP_CTA = 'Get started';

/** Secondary CTA for Growth / Enterprise */
export const SCHEDULE_CALL_CTA = 'Schedule a call';

export { VESTA_SALES_CALENDAR };
